import { useMutation, useQueryClient } from 'react-query'
import { trackedChangeCommentsKeys } from './trackedChangeCommentsKeys'

import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { trackedChangesKeys } from '../trackedChanges/trackedChangesKeys'
import { buildErrorMessage } from 'utils'
import { useArticlePassword } from 'hooks/useArticlePassword'

interface Props {
  articleKey: string
  layerId: string
  trackedChangeId: string
  id: string
}

export const useDeleteTrackedChangeComment = ({ articleKey, layerId, trackedChangeId, id }: Props) => {
  const queryClient = useQueryClient()
  const password = useArticlePassword(articleKey)

  return useMutation<{}, Error, {}>(
    trackedChangeCommentsKeys.delete(trackedChangeId, id),
    async () => {
      const response = await sendToApi(
        `/articles/${articleKey}/layers/${layerId}/changes/${trackedChangeId}/comments/${id}`,
        { method: 'DELETE' },
      )

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(trackedChangesKeys.list(layerId, { password }))
      },
    },
  )
}
